import { render, staticRenderFns } from "./CardPaymentConfigEdit.vue?vue&type=template&id=585263b8"
import script from "./CardPaymentConfigEdit.vue?vue&type=script&lang=js"
export * from "./CardPaymentConfigEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports